import {
  useGetCmpAnalyticsByAppQuery,
  useGetCmpAnalyticsByLayoutByDayQuery,
  useGetCmpAnalyticsByLayoutQuery,
  useGetCmpAnalyticsBySdkQuery, useGetCmpAnalyticsByVendorQuery,
  useGetCmpAnalyticsConsentsOutputQuery,
  useGetCmpAnalyticsDataByDayQuery,
  useGetCmpAnalyticsDataByLangQuery,
  useGetCmpAnalyticsDataByOsQuery,
  useGetCmpAnalyticsDataByPurposeQuery,
  useGetCmpAnalyticsDataByRankQuery,
  useGetCmpAnalyticsQuery,
  useGetCmpAnalyticsRequestsByLangQuery, useGetCmpAnalyticsRequestsByLayoutQuery,
  useGetCmpAnalyticsRequestsByRankQuery
} from "../../api/cmpAnalyticsApiSlice";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

export default function useCmpAnalytics({skip = false, configurable = null}) {
  const { i18n } = useTranslation()

  const [filter, setFilter] = useState({})

  const params = useMemo(() => (configurable ? {...filter, configurable} : {...filter} ), [filter])

  const { data = {}, isSuccess, isFetching: isLoading} = useGetCmpAnalyticsQuery(params, {skip})
  const dataByDay = useGetCmpAnalyticsDataByDayQuery(params, {skip})
  const dataByPurpose = useGetCmpAnalyticsDataByPurposeQuery({...params, filter: {...filter, lang: i18n.language}}, {skip})
  const dataByOs = useGetCmpAnalyticsDataByOsQuery(params, {skip})
  const consentsOutput = useGetCmpAnalyticsConsentsOutputQuery(params, {skip})
  const dataByLang = useGetCmpAnalyticsDataByLangQuery(params, {skip})
  const requestsByLang = useGetCmpAnalyticsRequestsByLangQuery(params, {skip})
  const dataByRank = useGetCmpAnalyticsDataByRankQuery(params, {skip})
  const requestsByRank = useGetCmpAnalyticsRequestsByRankQuery(params, {skip})
  const dataByApp = useGetCmpAnalyticsByAppQuery(params, {skip})
  const dataBySdk = useGetCmpAnalyticsBySdkQuery(params, {skip})
  const dataByLayout = useGetCmpAnalyticsByLayoutQuery(params, {skip})
  const dataByLayoutByDay = useGetCmpAnalyticsByLayoutByDayQuery(params, {skip})
  const requestsByLayout = useGetCmpAnalyticsRequestsByLayoutQuery(params, {skip})
  const dataByVendor = useGetCmpAnalyticsByVendorQuery(params, {skip})

  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess) }

  const analytics = {
    dataByDay,
    dataByPurpose,
    dataByOs,
    consentsOutput,
    dataByLang,
    requestsByLang,
    dataByRank,
    requestsByRank,
    dataByApp,
    dataBySdk,
    dataByLayout,
    dataByLayoutByDay,
    requestsByLayout,
    dataByVendor
  }

  const kpis = useMemo(() => ({
    activeDevicesCount: data.activeDevicesCount,
    devicesWithCmpPresentedCount: data.devicesWithCmpPresentedCount,
    consentedDevicesCount: data.consentedDevicesCount
  }), [data.activeDevicesCount, data.devicesWithCmpPresentedCount, data.consentedDevicesCount])

  return {setFilter, loaderProps, data, analytics, kpis}
}
